module.exports = __webpack_public_path__ + "static/media/cover.4a116668.jpg";